
import React, { useState, useEffect } from 'react';
import styles from '@/pages/selfClosure/index.less';
import BaseForm from '@/components/BaseForm';
import { Form } from 'antd';
import { closureUrl } from '@/constants/api';
import { useOutletContext } from 'react-router-dom';
import { LoginInfo } from '@/types/index';
import { fetcher } from '@/utils/request';
import { checkWeGameBindDays } from '@/constants/api';
import useSWR from 'swr';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';
interface Yzm {
  captcha: string | undefined,
  cookies: string | undefined,
  balanceCode: string | undefined
}

interface Props {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setUuid: React.Dispatch<React.SetStateAction<string>>;
}

const StepFirst = (props: Props) => {
  
  const [form] = Form.useForm();
  const [serverValue, setServerValue] = useState('');
  const [serverCode, setServerCode] = useState(Number);
  const [refreshCaptcha, setRefreshCaptcha] = useState(0);
  const [submitErrorVal, setSubmitErrorVal] = useState('');
  const loginInfo: LoginInfo = useOutletContext();
  const setUpdateLogin = useSetAtom(loginAtom);

  const [yzm, setYzm] = useState({
    captcha: '',
    cookies: '',
    balanceCode: '',
  } as Yzm);

  const { data } = useSWR(checkWeGameBindDays + '?isUnSelf=true');

  useEffect(() => {
    if (data && data.retCode !== 'SUCCESS') {
      setSubmitErrorVal(data.message);
    }
  }, [data]);

  const onFinish = () => {
    if (!serverValue) {
      setSubmitErrorVal('请选择区服！');
      return;
    }
    if (!yzm?.captcha) {
      setSubmitErrorVal('请输入验证码！');
      return;
    }
    const params = `?gameId=2&serverId=${serverCode}&serverName=${serverValue}&captcha=${yzm.captcha}&cookies=${yzm.cookies}&balanceCode=${yzm.balanceCode}&isUnSelf=true`;

    fetcher(`${closureUrl}${params}`, {credentials: 'include'}).then((res) => {
      if (res.retCode !== 'SUCCESS') {
        setSubmitErrorVal(res.message);
        setRefreshCaptcha(Math.random());
      }else {
        setSubmitErrorVal('');
        props.setStep(1);
        props.setUuid(res.data.uuid);
      }
    });
  };

  const getConditions = () => {
    return [
      {
        label: '问题账号',
        type: 'TEXT',
        name: 'account',
        key: 'account',
        render: () => <div style={{ color: '#c00', fontWeight: 700 }}>{loginInfo.account}</div>,
      },
      {
        label: '游戏',
        type: 'TEXT',
        name: 'name',
        key: 'name',
        render: () => '问道',
      },
      {
        label: '区服',
        type: 'GAME_SERVER',
        name: 'server',
        key: 'server',
        options: {
          status: 'activation',
          gameId: 2,
          isWeGame: true,
          setValueFn: (serverVal: {code: number;
            serverName: string}) => {
            setServerValue(serverVal.serverName);
            setServerCode(serverVal.code);
            form.setFieldsValue({ server: serverVal.code });
          },
          serIptClassName: styles.netTypeNameInput,
          serSelClassName: styles.sever_sel_btn
        },
      },
      {
        label: '验证码',
        type: 'CAPTCHA',
        key: 'captcha',
        name: 'completed',
        options: {
          bId: 'j14hnaupnmpn',
          refreshCaptcha: refreshCaptcha,
          onSubmit: (data: any) => {
            setYzm({
              balanceCode: data.balanceCode,
              cookies: data.cookies,
              captcha: data.captcha,
            });
          },
        },
      },
      {
        type: 'BUTTON',
        name: 'btn_e_key_game_pay',
        key: 'btn_game_pay',
        options: {
          text: '下一步',
          onClick: () => {
            console.log('res',loginInfo);
            if (!loginInfo?.isLogin) {
              setUpdateLogin?.({isLogin: false, visibleLogin: true});
            }
          },
        },
      },
    ];
  };

  return (
    <div className='stepFirstBox'>
      <div className="submit_error" style={{ display: submitErrorVal ? 'block' : 'none' }}>
        {
          submitErrorVal.indexOf('您尚未激活该区服') > -1 ? <div className="error_val">
            {submitErrorVal.split('&nbsp;')[0]}<span dangerouslySetInnerHTML={{__html: submitErrorVal.split('&nbsp;')[1]}}></span>
          </div> : <div className="error_val">
            {submitErrorVal}
          </div>
        }
      </div>
      <BaseForm conditions={getConditions()} onFinish={onFinish} />
    </div>
  );
};

export default StepFirst;
